<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img" style="background:#f4f4f4; height:100vh;">
    <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <div class="nopage-hld text-center">
          <figure class="nopage-logo" style="margin-top:50px">
            <a href="javascript:void(0)">
              <img src="../assets/Images/on-air-logo.png" alt="Logo" width="300" />
            </a>
          </figure>
          <img src="../assets/Images/ErrorImg.png" />
          <h2 style="margin:20px 100px; font-size:1.5rem; ">
            We couldn't find the page!
            <div>The page you've requested cannot be displayed. It appears you've missed your intended destination, either through a bad or outdated link, or a typo in the page you were hoping to reach.</div>
          </h2>
          <div>
            <router-link
              v-show="eventSelected"
              size="large"
              style="color: white !important"
              class="btn-back"
              to="/lobby"
            >Return To Lobby</router-link>
            <router-link style="color: white !important" size="large" class="btn-back" to="/">Return To Login</router-link>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<style>
.btn-back {
  background: #139848 url(/img/proceed-arw.c5be15eb.svg) no-repeat right 10px
    center / 20px !important;
  border: 0;
  font-size: 16px !important;
  padding: 8px 40px 8px 25px !important;
  height: 35px;
  color: #ffffff;
  font-weight: 500 !important;
  text-transform: uppercase;
  text-align: center;
  border-radius: 5px;
  text-decoration: none;
  margin-left: 15px;
}
.btn-back:hover {
  color: #ffffff;
}
</style>
<script>
// import jQuery from "jquery";
// let $ = jQuery;
export default {
  data() {
    return {
      eventSelected: false,
    };
  },
  mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    window.Tawk_API.onLoad = function () {
      window.Tawk_API.hideWidget();
    };
    if (obj.eventcollectionname != undefined && obj.eventcollectionname != "") {
      this.eventSelected = true;
    }

    // $("#topmenu").hide();
    // $("#leftmenu").hide();
  },
};
</script> 

